import { useCallback } from "react";
import { TrackingEvents } from "../../events";
import { sendFullStoryEvent } from "../../fullstory/events";
import { useRoomEventListeners } from "../../session/useRoomEventListeners";
import { UserType } from "../../types";
import type { RoomEventHandlerMap } from "../../video-sdk";
import { parseIdentity } from "../../video-sdk";
import { useLeaveSessionCallback } from "./useLeaveSessionCallback";

export function useClientRoomEventListeners() {
  const leaveSession = useLeaveSessionCallback();
  const onPageUnload = () => {
    sendFullStoryEvent(TrackingEvents.CLIENT_TAB_CLOSE);
  };
  const onParticipantDisconnect = useCallback<
    RoomEventHandlerMap["participantDisconnected"]
  >(
    function leaveIfProviderLeft(participant) {
      const { userType } = parseIdentity(participant.identity);
      if (userType !== UserType.PROVIDER) return;
      leaveSession();
    },
    [leaveSession],
  );

  useRoomEventListeners({
    onParticipantDisconnect,
    onRoomDisconnect: leaveSession,
    onPageUnload,
  });
}
